import script from "./InstructionCreatioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionCreatioPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionCreatioPage.vue?vue&type=style&index=0&id=6171b2ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6171b2ec"]])

export default __exports__